import {
  File as FileEnum,
  Persona,
} from "@funded-here-interface/common/src/constant/enum";
import type { DocumentsUpload } from "@funded-here-interface/common/src/constant/type";
import type { Data } from "../../../types/org.type";

export interface DocumentConfig {
  field: keyof DocumentsUpload;
  header: string;
  fileType: FileEnum;
  condition?: (data: Data | undefined, role?: Persona) => boolean;
}

/**
 * Configuration array for document rendering
 * Centralizes all document field definitions in one place
 */
export const documentConfigs: DocumentConfig[] = [
  {
    field: "certificateOfIncorporation",
    header: "Certificate of Incorporation",
    fileType: FileEnum.CERTIFICATE_OF_INCORPORATION,
  },
  {
    field: "businessProfile",
    header: "Company/Business Profile (within last 3 months)",
    fileType: FileEnum.BUSINESS_PROFILE,
  },
  {
    field: "companyConstitution",
    header: "Company Constitution / Memorandum & Articles of Association",
    fileType: FileEnum.COMPANY_CONSTITUTION,
  },
  {
    field: "shareHoldersDirectorsRegisters",
    header: "Shareholders and Directors Register",
    fileType: FileEnum.SHAREHOLDERS_DIRECTORS_REGISTERS,
  },
  {
    field: "balanceSheetPAndLStatement",
    header: "Financial Documents",
    fileType: FileEnum.BALANCE_SHEET,
  },
  {
    field: "proofOfAddress",
    header: "Proof of Residential Address",
    fileType: FileEnum.PROOF_OF_ADDRESS,
  },
  {
    field: "financialStatement",
    header: "Financial Documents",
    fileType: FileEnum.FINANCIAL_STATEMENT,
  },
  {
    field: "salaryProof",
    header: "Financial Documents",
    fileType: FileEnum.SALARY_PROOF,
  },
  {
    field: "proofOfBankAccountDetails",
    header: "Proof of Bank Account Details",
    fileType: FileEnum.PROOF_OF_BANK_ACCOUNT_DETAILS,
  },
  {
    field: "crsSelCertificationForm",
    header: "CRS Self-Certification Form",
    fileType: FileEnum.CRS_SELF_CERTIFICATION_FORM,
  },
  {
    field: "investmentMandate",
    header: "Investment Mandates",
    fileType: FileEnum.INVESTMENT_MANDATE,
  },
  {
    field: "fundManagerLicense",
    header: "Fund Manager License",
    fileType: FileEnum.FUND_MANAGER_LICENSE,
  },
  {
    field: "bankStatement",
    header: "Proof of Bank Account Details",
    fileType: FileEnum.BANK_STATEMENT,
  },
  {
    field: "supportingDocumentsWithSuppliers",
    header: "Supporting Documents with Suppliers",
    fileType: FileEnum.SUPPORTING_DOCUMENTS_WITH_SUPPLIERS,
    condition: (data, role) => {
      // Show different header for distributors
      return data?.orgRole?.[0]?.role?.name !== Persona.DISTRIBUTOR;
    },
  },
];

/**
 * Gets the appropriate header text based on role
 */
export const getDocumentHeader = (
  config: DocumentConfig,
  data: Data | undefined
): string => {
  if (
    config.field === "supportingDocumentsWithSuppliers" &&
    data?.orgRole?.[0]?.role?.name === Persona.DISTRIBUTOR
  ) {
    return "Additional Supporting Documents";
  }
  return config.header;
};
